module.exports = __webpack_public_path__ + "img/3768D4_1_0.9add8e4.svg";